import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { DzMicroactionModule } from '@blk/daisy/combinations/microactions';
import { DAISY_ICONS } from '@blk/daisy/core/icon';
import { DzButtonModule } from '@blk/daisy/elements/buttons';
import { AnalyticsModule } from '@ddt-web/analytics';
import { NewFeatureHighlightsModule } from '@ddt-web/new-feature-highlights';
import { faQuestionCircle } from '@fortawesome/free-solid-svg-icons';

import { TakeTourLinkComponent } from './take-tour-link.component';


@NgModule({
	declarations: [TakeTourLinkComponent],
	imports: [
		CommonModule,
		CwpNgFrameworkModule,
		NewFeatureHighlightsModule,
		AnalyticsModule,
		DzButtonModule,
		DzMicroactionModule
	],
	providers: [
		{
			provide: DAISY_ICONS,
			useValue: [faQuestionCircle],
			multi: true
		}
	],
	exports: [
		TakeTourLinkComponent
	]
})
export class TakeTourLinkModule { }
